import React, { Component } from 'react'
import { connect } from 'react-redux'

import WindowSpinner from '../WindowSpinner'
import Line from './Line'
import Hole from '../Dashboard/Hole'

import Person from './Person'

import {
  loadDetections,
  loadLots,
  assignLot,
  removeLotPerson,
  addLotPerson,
  setResolvedStatus,
  callDetails
} from '../../actions'
import { envConstants } from '../../constants'
import OrderBy from './OrderBy'

const initialState = {
  lotId: null,
  lotName: null,
  showDetections: true,
  showManagers: false,
  showInspectors: false,
  showMaintainers: false,
  chkList: [],
  selectedLot: '',
  maintainer_name: '',
  maintainer_email: '',
  maintainer_password: '',
  inspector_name: '',
  inspector_email: '',
  inspector_password: '',
  manager_name: '',
  manager_email: '',
  manager_password: '',
  searchText: '',
  searchAnomalyType: '',
  searchOrderDir: 1,
  searchOrderField: 'id',
  showDetails: false
}

class LotDetails extends Component {
  constructor() {
    super()
    this.state = initialState
    this.setChecked = this.setChecked.bind(this)
    this.deletePerson = this.deletePerson.bind(this)
    this.setResolved = this.setResolved.bind(this)
    this.handleClickDetails = this.handleClickDetails.bind(this)
    this.hideDetails = this.hideDetails.bind(this)
  }

  setChecked(e, d) {
    if (e.target.name === 'resolved') {
      return
    }
    const exists = this.state.chkList.filter((x) => x === d.id)
    if (exists.length > 0) {
      this.setState({ chkList: this.state.chkList.filter((x) => x !== d.id) })
    } else {
      this.setState({ chkList: this.state.chkList.concat(d.id) })
    }
  }

  setResolved(e, hole) {
    this.props.setResolvedStatus({ id: hole.id, status: hole.status })
  }

  assignLot() {
    this.props.assignLot({
      lot: this.state.selectedLot,
      list: this.state.chkList,
      fromLot: this.state.lotId
    })
  }

  deletePerson(p, role) {
    this.props.removeLotPerson({ email: p.email, role, lot: this.state.lotId })
  }

  addManager() {
    const s = this.state
    this.props.addLotPerson({
      email: s.manager_email,
      name: s.manager_name,
      password: s.manager_password,
      role: 1,
      lot: this.state.lotId
    })
  }

  addInspector() {
    const s = this.state
    this.props.addLotPerson({
      email: s.inspector_email,
      name: s.inspector_name,
      password: s.inspector_password,
      role: 2,
      lot: this.state.lotId
    })
  }

  addMaintainer() {
    const s = this.state
    this.props.addLotPerson({
      email: s.maintainer_email,
      name: s.maintainer_name,
      password: s.maintainer_password,
      role: 3,
      lot: this.state.lotId
    })
  }

  filterSortList(list) {
    if (!list) {
      return []
    }
    const s = this.state
    let rtrn = list
    const regex = s.searchText
      .split(' ')
      .filter((x) => x !== '')
      .map((item) => {
        return item.trim()
      })
    if (s.searchText !== '' || s.searchAnomalyType !== '') {
      rtrn = list.filter((x) => {
        const txt =
          x.formattedAddress.toString() +
          ' ' +
          x.region.toString() +
          ' ' +
          x.id.toString()
        let c = 0
        regex.forEach((r) => {
          c += txt.match(new RegExp(r, 'igm')) ? 1 : 0
        })
        return (
          c >= regex.length &&
          (s.searchAnomalyType !== ''
            ? x.anomalyType === s.searchAnomalyType
            : true)
        )
      })
    }
    if (s.searchOrderDir < 0) {
      return rtrn.sort((a, b) =>
        a[s.searchOrderField] < b[s.searchOrderField] ? 1 : -1
      )
    }
    return rtrn.sort((a, b) =>
      a[s.searchOrderField] > b[s.searchOrderField] ? 1 : -1
    )
  }

  orderBy(field) {
    const s = this.state
    let no = s.searchOrderDir
    if (s.searchOrderField === field) {
      no = s.searchOrderDir * -1
    }
    this.setState({
      searchOrderDir: no,
      searchOrderField: field
    })
  }

  selDesAll(list) {
    const s = this.state
    if (s.chkList.length === list.length) {
      this.setState({ chkList: [] })
    } else {
      this.setState({ chkList: list.map((x) => x.id) })
    }
  }

  handleClickDetails(id) {
    this.setState({ showDetails: true })
    this.props.callDetails(id)
  }

  hideDetails() {
    this.setState({ showDetails: false })
  }

  componentDidMount() {
    if (this.state.lotId === null) {
      // const id = this.props.match.params.id
      // const name = this.props.match.params.name
      const [, id, name] = window.location.pathname
        .split('/')
        .filter((x) => x !== '')

      this.setState({
        lotId: parseInt(id),
        lotName: name
      })
      this.props.loadDetections(id)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const p = prevProps.detections
    const c = this.props.detections
    if (p.loading && !c.loading) {
      this.setState({
        chkList: [],
        selectedLot: '',
        maintainer_name: '',
        maintainer_email: '',
        maintainer_password: '',
        inspector_name: '',
        inspector_email: '',
        inspector_password: '',
        manager_name: '',
        manager_email: '',
        manager_password: ''
      })
    }
  }

  render() {
    const {
      loading,
      list,
      lots,
      managers,
      maintainers,
      inspectors,
      hideManager
    } = this.props.detections
    const loadingDetails = this.props.dashboard.loading
    const s = this.state
    const filteredList = this.filterSortList(list)
    return (
      <div className='full-page'>
        <button
          className='lnk-det-refresh'
          onClick={() => this.props.loadDetections(s.lotId)}
        >
          <i className='fas fa-sync-alt'></i>
        </button>
        <h1>Lotto: {s.lotName}</h1>
        <h2
          className='rltv caret'
          onClick={() => this.setState({ showDetections: !s.showDetections })}
        >
          Anomalie ({(list || []).length})
          <i
            className={'fas fa-caret-' + (s.showDetections ? 'up' : 'down')}
          ></i>
        </h2>
        {s.showDetections && (
          <div>
            <ul className='ul-detections'>
              <li className='field'>
                <select
                  onChange={(e) =>
                    this.setState({ selectedLot: e.target.value })
                  }
                  disabled={s.chkList.length === 0}
                  value={this.state.selectedLot}
                >
                  <option value=''></option>
                  {(lots || [])
                    .filter((x) => x.id !== s.lotId)
                    .map((l, index) => {
                      return (
                        <option key={index} value={l.id}>
                          {l.name}
                        </option>
                      )
                    })}
                </select>
              </li>
              <li className='big'>
                <button
                  className='lnk-edit-lot big'
                  onClick={() => this.assignLot()}
                  disabled={s.chkList.length === 0 || s.selectedLot === ''}
                >
                  Sposta <b>{s.chkList.length}</b> anomalie
                </button>
              </li>
            </ul>
            <ul className='ul-detections'>
              <li className='move'>
                <button
                  disabled={filteredList.length === 0}
                  className='lnk-sel-des-all'
                  onClick={() => this.selDesAll(filteredList)}
                >
                  <i className='fas fa-check-double'></i>
                </button>
              </li>
              <li>
                <input
                  type='text'
                  placeholder='Cerca'
                  value={s.searchText}
                  onChange={(e) =>
                    this.setState({ searchText: e.target.value })
                  }
                />
              </li>
              <li>
                <select
                  onChange={(event) =>
                    this.setState({ searchAnomalyType: event.target.value })
                  }
                  value={this.state.searchAnomalyType}
                >
                  <option value=''>Tipo anomalia</option>
                  {envConstants.anomalyTypes.map((t, index) => {
                    return (
                      <option value={t} key={index}>
                        {t}
                      </option>
                    )
                  })}
                </select>
              </li>
            </ul>
            <ul className='detection-container header no-hover'>
              <li className='severity' onClick={() => this.orderBy('status')}>
                <OrderBy
                  dir={s.searchOrderDir}
                  field='status'
                  current={s.searchOrderField}
                />
              </li>
              <li className='id' onClick={() => this.orderBy('id')}>
                id{' '}
                <OrderBy
                  dir={s.searchOrderDir}
                  field='id'
                  current={s.searchOrderField}
                />
              </li>
              <li
                className='address'
                onClick={() => this.orderBy('formattedAddress')}
              >
                indirizzo{' '}
                <OrderBy
                  dir={s.searchOrderDir}
                  field='formattedAddress'
                  current={s.searchOrderField}
                />
              </li>
              <li className='ld' onClick={() => this.orderBy('lastDetection')}>
                ultima rilevazione{' '}
                <OrderBy
                  dir={s.searchOrderDir}
                  field='lastDetection'
                  current={s.searchOrderField}
                />
              </li>
              <li className='type' onClick={() => this.orderBy('anomalyType')}>
                tipo anomalia{' '}
                <OrderBy
                  dir={s.searchOrderDir}
                  field='anomalyType'
                  current={s.searchOrderField}
                />
              </li>
              <li className='severity' onClick={() => this.orderBy('severity')}>
                <OrderBy
                  dir={s.searchOrderDir}
                  field='severity'
                  current={s.searchOrderField}
                />
              </li>
              <li className='id' onClick={() => this.orderBy('status')}>
                imposta stato{' '}
                <OrderBy
                  dir={s.searchOrderDir}
                  field='status'
                  current={s.searchOrderField}
                />
              </li>
            </ul>
            {(filteredList || []).map((d, index) => {
              return (
                <Line
                  key={index}
                  setChecked={this.setChecked}
                  chkList={this.state.chkList}
                  d={d}
                  setResolved={this.setResolved}
                  handleClickDetails={this.handleClickDetails}
                />
              )
            })}
          </div>
        )}
        {s.lotId > 0 && (
          <div>
            {!hideManager && (
              <>
                <h2
                  className='rltv caret'
                  onClick={() =>
                    this.setState({ showManagers: !s.showManagers })
                  }
                >
                  Gestori lotto ({(managers || []).length})
                  <i
                    className={
                      'fas fa-caret-' + (s.showManagers ? 'up' : 'down')
                    }
                  ></i>
                </h2>
                {s.showManagers && (
                  <div>
                    <ul className='ul-detections'>
                      <li className='name'>
                        <input
                          type='text'
                          placeholder='Nome gestore'
                          onChange={(e) =>
                            this.setState({ manager_name: e.target.value })
                          }
                          value={this.state.manager_name}
                        />
                      </li>
                      <li className='email'>
                        <input
                          type='email'
                          placeholder='Email'
                          onChange={(e) =>
                            this.setState({ manager_email: e.target.value })
                          }
                          value={this.state.manager_email}
                        />
                      </li>
                      <li className='email'>
                        <input
                          type='text'
                          placeholder='Password'
                          onChange={(e) =>
                            this.setState({ manager_password: e.target.value })
                          }
                          value={this.state.manager_password}
                        />
                      </li>
                      <li className='btn'>
                        <button
                          className='lnk-edit-lot'
                          onClick={() => this.addManager()}
                          disabled={
                            s.manager_name === '' ||
                            s.manager_email === '' ||
                            s.manager_password === '' ||
                            managers.filter(
                              (x) => x.email === this.state.manager_email
                            ).length > 0
                          }
                        >
                          Aggiungi
                        </button>
                      </li>
                    </ul>
                    {(managers || []).map((p, index) => {
                      return (
                        <Person
                          key={index}
                          p={p}
                          r={1}
                          deletePerson={this.deletePerson}
                        />
                      )
                    })}
                  </div>
                )}
              </>
            )}
            <h2
              className='rltv caret'
              onClick={() =>
                this.setState({ showInspectors: !s.showInspectors })
              }
            >
              Ispettori ({(inspectors || []).length})
              <i
                className={'fas fa-caret-' + (s.showInspectors ? 'up' : 'down')}
              ></i>
            </h2>
            {s.showInspectors && (
              <div>
                <ul className='ul-detections'>
                  <li className='name'>
                    <input
                      type='text'
                      placeholder='Nome manutentore'
                      onChange={(e) =>
                        this.setState({ inspector_name: e.target.value })
                      }
                      value={this.state.inspector_name}
                    />
                  </li>
                  <li className='email'>
                    <input
                      type='email'
                      placeholder='Email'
                      onChange={(e) =>
                        this.setState({ inspector_email: e.target.value })
                      }
                      value={this.state.inspector_email}
                    />
                  </li>
                  <li className='email'>
                    <input
                      type='text'
                      placeholder='Password'
                      onChange={(e) =>
                        this.setState({ inspector_password: e.target.value })
                      }
                      value={this.state.inspector_password}
                    />
                  </li>
                  <li className='btn'>
                    <button
                      className='lnk-edit-lot'
                      onClick={() => this.addInspector()}
                      disabled={
                        s.inspector_name === '' ||
                        s.inspector_email === '' ||
                        s.inspector_password === '' ||
                        inspectors.filter(
                          (x) => x.email === this.state.inspector_email
                        ).length > 0
                      }
                    >
                      Aggiungi
                    </button>
                  </li>
                </ul>
                {(inspectors || []).map((p, index) => {
                  return (
                    <Person
                      key={index}
                      p={p}
                      r={2}
                      deletePerson={this.deletePerson}
                    />
                  )
                })}
              </div>
            )}
            <h2
              className='rltv caret'
              onClick={() =>
                this.setState({ showMaintainers: !s.showMaintainers })
              }
            >
              Manutentori ({(maintainers || []).length})
              <i
                className={
                  'fas fa-caret-' + (s.showMaintainers ? 'up' : 'down')
                }
              ></i>
            </h2>
            {s.showMaintainers && (
              <div>
                <ul className='ul-detections'>
                  <li className='name'>
                    <input
                      type='text'
                      placeholder='Nome manutentore'
                      onChange={(e) =>
                        this.setState({ maintainer_name: e.target.value })
                      }
                      value={this.state.maintainer_name}
                    />
                  </li>
                  <li className='email'>
                    <input
                      type='email'
                      placeholder='Email'
                      onChange={(e) =>
                        this.setState({ maintainer_email: e.target.value })
                      }
                      value={this.state.maintainer_email}
                    />
                  </li>
                  <li className='email'>
                    <input
                      type='text'
                      placeholder='Password'
                      onChange={(e) =>
                        this.setState({ maintainer_password: e.target.value })
                      }
                      value={this.state.maintainer_password}
                    />
                  </li>
                  <li className='btn'>
                    <button
                      className='lnk-edit-lot'
                      onClick={() => this.addMaintainer()}
                      disabled={
                        s.maintainer_name === '' ||
                        s.maintainer_email === '' ||
                        s.maintainer_password === '' ||
                        maintainers.filter(
                          (x) => x.email === this.state.maintainer_email
                        ).length > 0
                      }
                    >
                      Aggiungi
                    </button>
                  </li>
                </ul>
                {(maintainers || []).map((p, index) => {
                  return (
                    <Person
                      key={index}
                      p={p}
                      r={3}
                      deletePerson={this.deletePerson}
                    />
                  )
                })}
              </div>
            )}
          </div>
        )}

        {(loading || loadingDetails) && <WindowSpinner />}
        {this.state.showDetails && (
          <Hole hideDetails={this.hideDetails} index={-1} />
        )}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  loadDetections,
  loadLots,
  assignLot,
  removeLotPerson,
  addLotPerson,
  setResolvedStatus,
  callDetails
})(LotDetails)
